import React from 'react';
import '../style/toba.css'
import Button from "./button";
import GeneralSVG from "./generalSVG";
import '../style/dots.css';
import Dots from 'react-activity/lib/Dots';
import FormResponseMessage from "./formResponseMessage";
import CustomModal from "./General/customModal";
import CenteredDots from "./General/centeredDots";
import { TOBA_FULL_TEXT} from '../helpers/variables';

const Toba = (props) => {

    if (props.user.fetchingPendingToba) {
        return (
            <div className="col-sm-12">
                <CenteredDots/>
            </div>
        )
    }

    return (
        <div className="row">
            <CustomModal
                contentClassname='tobas__toba-modal'
                isOpen={props.user.isTobaRejectModalOpen}
                content={props.tobaRejectModalContent}
                handleClose={props._closeTobaRejectModal}
            />
            <div className="col-xs-8">
            <h2 className="toba-h2">{TOBA_FULL_TEXT}</h2>
                <p className="toba-paragraph"> {props.user.tobaMessage.body}
                </p>
                <div className="" dangerouslySetInnerHTML={{__html: props.user.toba.content}}>
                </div>
            </div>
            {
                props.user.toba.tobaAttachmentDtos?
                    props.user.toba.tobaAttachmentDtos.length > 0?
                            <div className="col-sm-12">
                                <h4 >Files Attached</h4>
                                <ul className="newApplication-attachment-list">
                                    {
                                        props.user.toba.tobaAttachmentDtos.map((attachments, index) => {
                                            return <li key={index}>
                                                <a onClick={() => props._getFileFromBase64(attachments)}
                                                   className="applicationPolicy-document-tab-link">
                                                    <GeneralSVG
                                                        SvgWrapper="generalTab-download-wrapper inlineBlock"
                                                        Label="Download"
                                                        Svg={<svg xmlns="http://www.w3.org/2000/svg"
                                                                  viewBox="0 0 10 10"><title>Asset
                                                            9</title>
                                                            <g id="Layer_2" data-name="Layer 2">
                                                                <g id="info">
                                                                    <path
                                                                        d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                                    <path
                                                                        d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                                </g>
                                                            </g>
                                                        </svg>}
                                                    />
                                                </a>
                                                {' ' + attachments.name}
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        :
                        null
                    :
                    null
            }
            <div className="col-xs-12">
                <Button
                    clickHandler={() => {
                        props.postAcceptToba(props.user.toba.id);
                        props.toggleToba()
                    }}
                    wrapper="btn-wrapper"
                    btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                    label="Accept"/>
            </div>
            {
                props.locationPathName === '/accept-toba'?
                   <div className={'col-xs-12 mt-15 mb-15'}>
                       <Button
                           clickHandler={() => {
                               props.goBack()
                           }}
                           wrapper="btn-wrapper"
                           btnType="submit" btnStyle={'btn btn-primary btn-xs sharp white'}
                           label="Go back"/>
                   </div>
                    :
                    <div className="col-xs-12">
                        <div onClick={props._openTobaRejectModal} className="inlineBlock toba-reject-wrapper">
                            <GeneralSVG
                                SvgWrapper="generalTab-readMore-wrapper"
                                Label={'Reject'}
                                Svg={<svg xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 9.6 16"><title>Asset
                                    2</title>
                                    <g id="Layer_2" data-name="Layer 2">
                                        <g id="Layer_1-2"
                                           data-name="Layer 1">
                                            <path
                                                d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                        </g>
                                    </g>
                                </svg>}
                            />
                        </div>
                    </div>
            }
            <h6 className={'col-xs-12'}>
                {'Name: ' + props.user.toba.name + ' | Version: ' + props.user.toba.version}
            </h6>
            {
                props.user.acceptingToba ?
                    <div className="col-sm-12">
                        <CenteredDots/>
                    </div>
                    :
                    null
            }
            {
                props.user.failedToAcceptToba ?
                    <div className={'col-xs-12'}>
                        <form className="form-horizontal">
                            <FormResponseMessage
                                LeftWrapper=""
                                CenterWrapper="col-sm-12"
                                MessageStyle="formResponseMessage-reject"
                                Message={props.user.failedToAcceptToba}/>
                        </form>
                    </div>
                    :
                    null
            }
        </div>
    )
};

export default Toba;